import React, { useState } from 'react'
import { toast } from 'react-toastify';
import { base_url } from '../../utils/AxiosConfig';
import axios from 'axios';


const AddTimeSheetPopup = ({ popUpData }) => {

  const storedUserDataArray = JSON.parse(localStorage.getItem("BondTimeuserDataArray")) || [];
  let companyCode = null

  if (storedUserDataArray) {
    companyCode = storedUserDataArray[0].cmpcode
  }


  const [timeSheetData, setTimeSheetData] = useState({
    startDate: "",
    endDate: ""
  })

  const [isLoading, setIsLoading] = useState(false);

  // Handle input change
  const handleChange = (e) => {
    const { name, value } = e.target;
    setTimeSheetData({
      ...timeSheetData,
      [name]: value,
    });
  };

  // Handle form submission
  const handleSubmit = async () => {
    setIsLoading(true);
    try {
      const payload = [
        {
          mode: "ENTRY",
          cmpcode: companyCode,
          Empid: popUpData?.EmpId,
          StartDate: timeSheetData.startDate,
          EndDate: timeSheetData.endDate,
          deptno: "-",
          jobcode: "-",
        },
      ];

      console.log("payload ", payload)

      const response = await axios.post(
        `${base_url}api/TimesheetReg`,
        payload,
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      if (response.status === 200) {
        toast.success("Timesheet submitted successfully!");
        setTimeSheetData({
          startDate: "",
          endDate: ""
        })
      } else {
        toast.error("Failed to submit timesheet.");
      }
    } catch (error) {
      toast.error("An error occurred while submitting timesheet.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div>
      <div class="modal fade" id="staticBackdrop" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg">
          <div class="modal-content">
            <div class="modal-header">
              <h1 class="modal-title  text-secondary fs-small" id="staticBackdropLabel">Add Timesheet (wps)</h1>
              <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
            </div>
            <div class="modal-body">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-6">
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Emp ID</label>
                      <input type="text" class="form-control" value={popUpData?.EmpId} disabled />

                    </div>
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Emp Name</label>
                      <input type="text" class="form-control" value={popUpData?.Name} disabled />

                    </div>

                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Designation</label>
                      <input type="text" class="form-control" value={popUpData?.JobTitle} disabled />

                    </div>
                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Date</label>
                      <input type="text" class="form-control" disabled />

                    </div> */}
                  </div>
                  <div className="col-md-6">

                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Time</label>
                      <input type="text" class="form-control" disabled />

                    </div> */}

                    {/* 
                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Department</label>
                      <input type="text" class="form-control" />

                    </div> */}

                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Start Date</label>
                      <input type="date"
                        class="form-control"
                        id="startDate"
                        name="startDate"
                        value={timeSheetData.startDate}
                        onChange={handleChange}
                      />

                    </div>

                    <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">End Date</label>
                      <input
                        type="date"
                        class="form-control"
                        id="endDate"
                        name="endDate"
                        value={timeSheetData.endDate}
                        onChange={handleChange}
                      />

                    </div>

                    {/* <div class="mb-3">
                      <label for="exampleInputEmail1" class="form-label fs-small text-secondary">Grade</label>
                      <input type="text" class="form-control" />

                    </div> */}
                  </div>
                </div>


              </div>
            </div>
            <div class="modal-footer">

              <button
                className="btn btn-primary"
                onClick={handleSubmit}
                disabled={isLoading}
              >
                {isLoading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddTimeSheetPopup
